




























































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import { mapState } from 'vuex';

import { objectIsEmpty } from '~/utils/common.js';
import { providerType, providerSubType, replaceUrl } from '~/utils/explorer.js';

import ChevronRightSolid from '~/components/icons/ChevronRightSolid.vue';
import ProfileRunSportTag from '~/components/partials/ProfileRunSportTag.vue';
import EventCategoryTag from '~/components/partials/EventCategoryTag.vue';
import PinOutline from '~/components/icons/PinOutline.vue';
import PlaySolid from '~/components/icons/PlaySolid.vue';
import ExternalOutline from '~/components/icons/ExternalOutline.vue';
import RelatedDestinationItem from '~/components/lists/items/RelatedDestinationItem.vue';
import ProvidersFeed from '~/components/lists/ProvidersFeed.vue';
import PhoneOutline from '~/components/icons/PhoneOutline.vue';
import RespectCard from '~/components/cards/RespectCard.vue';
import Breadcrumb from '~/components/partials/Breadcrumb.vue';
import FacebookSolid from '~/components/icons/FacebookSolid.vue';
import ShareSolid from '~/components/icons/ShareSolid.vue';
import CartOutline from '~/components/icons/CartOutline.vue';
import EatOutline from '~/components/icons/EatOutline.vue';
import BedSolid from '~/components/icons/BedSolid.vue';
import BinocularSolid from '~/components/icons/BinocularSolid.vue';
import InfoOutline from '~/components/icons/InfoOutline.vue';

@Component({
  components: {
    ChevronRightSolid,
    ProfileRunSportTag,
    EventCategoryTag,
    PinOutline,
    PlaySolid,
    ExternalOutline,
    RelatedDestinationItem,
    ProvidersFeed,
    PhoneOutline,
    RespectCard,
    Breadcrumb,
    FacebookSolid,
    ShareSolid,
  },
  middleware: ['noauth'],
  computed: {
    ...mapState('explorer', [
      'provider',
      'destination',
      'destinationProvidersSuggestions',
    ]),
    ...mapState('lang', [
      'locale',
    ]),
  },
  head () {
    const self: any = this;
    const description = self.provider.description?.trim().replace(/<\/?[^>]+(>|$)/g, "");
    const locale: string = self.$store.state.lang.locale;

    return {
      title: `${self.provider.title} - On Piste`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: description,
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: `${self.provider.title} - On Piste`,
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description,
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: self.provider.media?.length ? self.$thumbnailUrl(self.provider.media[0], 1200) : 'https://www.onpiste.com/img/placeholders/provider-placeholder.png',
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: `https://www.onpiste.com/${locale === 'fr' ? '' : `${locale}/`}explorer/service-providers/${self.$slugify(self.provider.title)}-${self.provider.id}`,
        },
      ],
    };
  },
  async fetch () {
    const self: any = this;
    await self.populateDestinationDatas();
  },
  async asyncData ({ store, route, error, app }) {
    const errorInstance: any = error;

    if (
      route.params.providerid.split('-').pop() === '' ||
      isNaN(Number(route.params.providerid.split('-').pop()?.trim()))
    ) {
      return errorInstance({
        statusCode: 404,
        response: { data: { detail: 'Unknown service_provider' } },
      });
    }

    try {
      if (route.query?.preview) {
        await store.dispatch('explorer/getProviderPreview', {
          id: route.params.providerid.split('-').pop()?.trim(),
          token: route.query.preview,
          lang: store.state.lang.locale,
        });
      } else {
        await store.dispatch('explorer/getProvider', {
          id: route.params.providerid.split('-').pop()?.trim(),
          lang: store.state.lang.locale,
        });
      }
    } catch (e) {
      return errorInstance({
        statusCode: e.response.status,
        response: { data: { detail: app.i18n.t(e.response.data.detail) } },
      });
    }
  },
})
export default class ProviderId extends Vue {
  provider: Types.Provider;
  destination: Types.DestinationItem;
  destinationProvidersSuggestions: Types.Provider[];
  locale: string;

  hashtags: Array<string> = ['Rossignol', 'On Piste'];

  /* Computed method to return complete URL of page for ShareNetwork button */
  get urlPage () {
    if (process.client) return window.location.href;
    return '';
  }

  /* Returns reactive array of breadcrumb links containing some store values */
  get breadcrumbMenu () {
    return [
      { path: '/', name: this.$t('explorer.providers.breadcrumb.home') },
      { path: '/explorer', name: this.$t('explorer.providers.breadcrumb.explorer') },
      this.destinationIsEmpty ? { path: ``, name: this.$t('explorer.destinations.unpublished') } : { path: `/explorer/destinations/${this.$slugify(`${this.destination.title}-${this.destination.id}`)}`, name: this.destination.title },
      {
        path: this.destinationIsEmpty ? '' : `/explorer/destinations/${this.$slugify(`${this.destination.title}-${this.destination.id}`)}/offer?tab=providers`,
        name: this.$t('explorer.providers.breadcrumb.providers'),
      },
      { path: '', name: this.provider?.title, isActive: true },
    ];
  }

  /* Returns reactive array of submenu links containing some store values */
  get subMenuLinks () {
    return [
      { link: '#description', name: this.$t('explorer.providers.submenu.description'), isDisplayed: true },
      { link: '#similar-providers', name: this.$t('explorer.providers.submenu.similar'), isDisplayed: this.destinationProvidersSuggestions?.length },
    ];
  }

  /* Returns translated provider subType using util */
  get providerSubType () {
    return providerSubType(this.provider?.subtype);
  }

  /* Returns translated provider type using util */
  get providerType () {
    return providerType(this.provider?.type);
  }

  /*
    Returns the link to all providers related to destination, using slugify
    to construct valid URL.
  */
  get linkToProviders () {
    return `/explorer/destinations/${this.$slugify(`${this.destination.title}-${this.destination.id}`)}/offer?tab=providers`;
  }

  /* Computed skeleton handle */
  get providerIsEmpty () {
    return objectIsEmpty(this.provider);
  }

  /* Switch to return providerIcon (Vue) based on provider type */
  get providerIcon () {
    switch (this.provider?.type) {
      case 'FOOD': return EatOutline;
      case 'SHOP': return CartOutline;
      case 'HOSTING': return BedSolid;
      case 'TODOTOSEE': return BinocularSolid;
      case 'SERVICE': return InfoOutline;
    }
  }

  /* Computed skeleton handle */
  get destinationIsEmpty () {
    return objectIsEmpty(this.destination);
  }

  mounted () {
    window.dataLayer.push({
      'Destination': this.destination.title,
      'DestinationID': this.destination.id,
    });

    /*
      Using util method to adapt URL to a specific format containing title and
      ID of retrieved element for better SEO.
    */
    replaceUrl(
      this.$route.params.providerid,
        `${this.locale !== 'fr' ? `/${this.locale}` : ''}/explorer/service-providers/${this.$slugify(this.provider.title)}`,
        this.$slugify(this.provider?.title),
    );
  }

  /* Image fallback if card <img @error> is triggered */
  imageFallback (event: any) {
    event.target.src = "/img/placeholders/provider-placeholder.png";
  }

  /*
    In SSR mode this method is called in fetch, before the page mounts.
    The tmeplate wil be rendered with datas of element.
  */
  async populateDestinationDatas () {
    await this.$store.dispatch('explorer/getDestination', {
      id: this.provider.destination_id,
      lang: this.locale,
    });

    await this.$store.dispatch('explorer/getProvidersSimilar', {
      id: this.provider.id,
      lang: this.locale,
    });
  }

  // redirectToExplorer (tag: Types.SportItem) {
  //   const route: any = this.localePath(`/explorer?sport=${tag.id}`);
  //   this.$router.push(route);
  // }
}
